import { createFileRoute } from "@tanstack/react-router";

import { FullAccessRule } from "src/api/generated/frontend_customer_v1";
import React from "react";
import ReadOnlyACLs from "src/components/acl";
import { BadgeButton } from "src/components/base/badges/base";
import SINGLE_TAG_CONTEXT from "src/context/customer/tag";

/**
 * The properties for {@link CustomerTagOutboundACLs}
 */
export type CustomerTagOutboundACLsProps = {};

/**
 * Outbound ACLs of a tag
 */
function CustomerTagOutboundACLs(props: CustomerTagOutboundACLsProps) {
    const ctx = React.useContext(SINGLE_TAG_CONTEXT);

    const groups: { [key: string]: Array<FullAccessRule> } = {};
    const subnets: { [key: string]: Array<FullAccessRule> } = {};
    const tags: { [key: string]: Array<FullAccessRule> } = {};

    for (const rule of ctx.tag.outbound_access_rules) {
        if (rule.dst.type === "Group") {
            if (groups[rule.dst.value.uuid] === undefined) {
                groups[rule.dst.value.uuid] = [];
            }
            groups[rule.dst.value.uuid].push(rule);
        } else if (rule.dst.type === "Tag") {
            if (tags[rule.dst.value.uuid] === undefined) {
                tags[rule.dst.value.uuid] = [];
            }
            tags[rule.dst.value.uuid].push(rule);
        } else if (rule.dst.type === "Subnet") {
            if (subnets[rule.dst.value.uuid] === undefined) {
                subnets[rule.dst.value.uuid] = [];
            }
            subnets[rule.dst.value.uuid].push(rule);
        }
    }

    return (
        <div className={"flex flex-col gap-6"}>
            {Object.entries(groups).map(([key, value]) => (
                <div key={key} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/groups/$groupId/inbound-acls"}
                        params={{ groupId: key }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`group:${value[0].dst.value.name}`}
                    </BadgeButton>
                    <ReadOnlyACLs rules={value} />
                </div>
            ))}

            {Object.entries(tags).map(([key, value]) => (
                <div key={key} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/tags/$tagId/inbound-acls"}
                        params={{ tagId: key }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`tag:${value[0].dst.value.name}`}
                    </BadgeButton>
                    <ReadOnlyACLs rules={value} />
                </div>
            ))}

            {Object.entries(subnets).map(([key, value]) => (
                <div key={key} className={"flex flex-col gap-6 rounded border p-3 dark:border-zinc-700"}>
                    <BadgeButton
                        href={"/c/subnets/$subnetId/inbound-acls"}
                        params={{ subnetId: key }}
                        className={"self-start"}
                        color={"blue"}
                    >
                        {`subnet:${value[0].dst.value.name}`}
                    </BadgeButton>
                    <ReadOnlyACLs rules={value} />
                </div>
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_customer/c/tags/$tagId/_tags/outbound-acls")({
    component: CustomerTagOutboundACLs,
});
